import { ReportColumnConfig } from '../../report-column';

export const deliveryReportColumnDefinition: ReportColumnConfig[] = [
            { key: 'divisionHierarchyLevel1Name', overrides: {order: 1, visible: false, rowGroup: true}},
            { key: 'divisionHierarchyLevel2Name', overrides: {order: 2, visible: false, rowGroup: true}},
            { key: 'divisionHierarchyLevel3Name', overrides: {order: 3, visible: false, rowGroup: true}},
            { key: 'divisionHierarchyLevel4Name', overrides: {order: 4, visible: false, rowGroup: true}},
            { key: 'divisionHierarchyLevel5Name', overrides: {order: 5, visible: false, rowGroup: true}},

            { key: 'deliveryCenterHierarchyLevel1Name', overrides: {order: 11, visible: false, rowGroup: false}},
            { key: 'deliveryCenterHierarchyLevel2Name', overrides: {order: 12, visible: false, rowGroup: false}},
            { key: 'deliveryCenterHierarchyLevel3Name', overrides: {order: 13, visible: false, rowGroup: false}},
            { key: 'deliveryCenterHierarchyLevel4Name', overrides: {order: 14, visible: false, rowGroup: false}},
            { key: 'deliveryCenterHierarchyLevel5Name', overrides: {order: 15, visible: false, rowGroup: false}},

            { key: 'productName', overrides: { order: 30, visible: true}},
            { key: 'transactionDeliveryTypeName', overrides: { order: 40, visible: true}},
            { key: 'deliveryDateTime', overrides: {order: 45}},
            { key: 'deliveryTime', overrides: {order: 46}},
            { key: 'deliveryDateMonth', overrides: { order: 50, header: 'Month', visible: true}},
            { key: 'deliveryDateYear', overrides: { order: 60, header: 'Year', visible: true}},
            { key: 'tradeClassName', overrides: { order: 70, visible: true}},
            { key: 'deliveryDate', overrides: { order: 80, visible: true } },

            { key: 'customerId', overrides: { order: 90, visible: true}},
            { key: 'customerName', overrides: { order: 91,  visible: true}},
            { key: 'customerAddressLine1', overrides: { order: 92, visible: false } },
            { key: 'customerAddressLine2', overrides: { order: 93, visible: false } },
            { key: 'customerCity', overrides: { order: 94, visible: false } },
            { key: 'customerState', overrides: { order: 95, visible: false } },
            { key: 'customerPostalCode', overrides: { order: 96, visible: false } },
            
            { key: 'containerId', overrides: { order: 110, visible: true}},
            { key: 'deliveredUnits', overrides: { order: 120, visible: true } },
            { key: 'deliveredUnitsToExpectedUnitsVariance', overrides: { order: 125, visible: true } },
            { key: 'expectedDeliveryUnits', overrides: { order: 130, visible: false } },
            { key: 'historicalTankMonitorFlag', overrides: { order: 160, visible: true}},
            { key: 'tankMonitorFlag', overrides: { order: 160, visible: true}},
            { key: 'capacity', overrides: { order: 170, visible: true } },
            { key: 'optimalDeliveryUnits', overrides: { order: 180, visible: true } },
            { key: 'usableUnits', overrides: { order: 190, visible: false } },
            { key: 'preDeliveryUnits', overrides: { order: 200, visible: false } },
            { key: 'partialFillFlag', overrides: { order: 210, visible: true}},
            { key: 'runOutFlag', overrides: { order: 220, visible: true}},
            { key: 'deliveryHoldPriorToDeliveryFlag', overrides: { order: 225, visible: true}},
            { key: 'potentialRunOut', overrides: { order: 230, visible: true}},
            { key: 'optimalDropPercentage', overrides: { order: 240, visible: true}},
            { key: 'capacityPercentage', overrides: { order: 250, visible: true}},
            { key: 'adjustedUnitsOptimalDropPercentage', overrides: { order: 260, visible: true}},
            { key: 'priorKFactor', overrides: { order: 270, visible: false } },
            { key: 'deliveryKFactor', overrides: { order: 280, visible: false } },
            { key: 'adjustedKFactor', overrides: { order: 285, visible: true } },
            { key: 'kFactorVariance', overrides: { order: 290, visible: true}},
            { key: 'deliveryGroupId', overrides: { order: 300, visible: true}},
            { key: 'sourceDeliveryZoneId', overrides: { order: 310, visible: true}},
            { key: 'sourceDeliveryZoneName', overrides: { order: 320, visible: true}},
            { key: 'sourceDeliveryZoneDescription', overrides: { order: 330, visible: true}},

            { key: 'customerLocationId', overrides: { order: 340, visible: false } },
            { key: 'customerLocationAddressLine1', overrides: { order: 341, visible: false } },
            { key: 'customerLocationAddressLine2', overrides: { order: 342, visible: false } },
            { key: 'customerLocationCity', overrides: { order: 343, visible: false } },
            { key: 'customerLocationState', overrides: { order: 344, visible: false } },
            { key: 'customerLocationPostalCode', overrides: { order: 345, visible: false } },
            
            { key: 'tankAcquisitionDate', overrides: { order: 380, visible: false } },
            { key: 'monitorInstallDate', overrides: { order: 390, visible: false } },
            { key: 'historicalBaseLoadUnits', overrides: { order: 400, visible: false } },
            { key: 'baseLoadUnits', overrides: {order: 410, visible: true}},
            { key: 'transactionSourceDeliveryTypeName', overrides: { order: 420, visible: false } },
            { key: 'postedDate', overrides: { order: 430, visible: false } },
            { key: 'usablePercentage', overrides: { order: 440, visible: true}},
            { key: 'customerOwnedFlag', overrides: { order: 450, visible: false } },
            { key: 'deliveryTypeName', overrides: { order: 460, visible: false } },
            { key: 'sourceDeliveryTypeName', overrides: { order: 470, visible: false } },
            { key: 'emailAddressCustomerLocation', overrides: { order: 480, header: 'Email', visible: true}},
            { key: 'driverName', overrides: { order: 490, visible: true}},
            { key: 'truckCode', overrides: { order: 500, visible: true}},
            { key: 'truckName', overrides: { order: 510, visible: true}},
            { key: 'salesRepName', overrides: { order: 520, header: 'Sales Rep', visible: false } },
            { key: 'deliveryRevenue', overrides: { order: 530, visible: false } },
            { key: 'deliveryMargin', overrides: { order: 540, visible: false } },
            { key: 'projectedUnitMargin', overrides: { order: 550, visible: false } },
            { key: 'transportationRate', overrides: { order: 560, visible: true}},
            { key: 'accountingDate', overrides: { order: 570, visible: false } },
            { key: 'sourcePreDeliveryFullPercent', overrides: { order: 580, header: 'Start %', visible: true}},
            { key: 'sourcePostDeliveryFullPercent', overrides: { order: 590, header: 'End %', visible: true}},
            { key: 'sourcePreDeliveryUnitsCalculatedFlag', overrides: { order: 600, header: 'Start % Est', visible: true}},
            { key: 'sourcePostDeliveryUnitsCalculatedFlag', overrides: { order: 610, header: 'End % Est', visible: true}},
            { key: 'containerLevelCount', overrides: { order: 620, visible: true}},
            { key: 'containerLevelPercentThirtyDays', overrides: { order: 630, visible: true}},
            { key: 'postDeliveryFullPercent', overrides: { order: 640, visible: true}},
            { key: 'calculatedTankSize', overrides: { order: 650, visible: true}},
            { key: 'calculatedTankSizeToCapacityPercentageDisplay', overrides: { order: 660, visible: true } },
            { key: 'monitorTypeName', overrides: { order: 680, visible: true } },
            { key: 'dealerName', overrides: { order: 690, visible: true } },
            { key: 'containerLevelPercentageFailureFlag', overrides: { order: 710, visible: true}},
            { key: 'calculatedTankSizeToCapacityPercentageFailureFlag', overrides: { order: 720, visible: true}},
            { key: 'monitorSerialNumber', overrides: { order: 730, visible: true } },
            { key: 'productCategoryName', overrides: {order: 740, visible: true}},
            { key: 'mostRecentLevelDatePriorToDelivery', overrides: { order: 750, visible: true } },
            { key: 'historicalTMSTankMonitorFlag', overrides: {order: 760, visible: true}},
            { key: 'tmsTankMonitorFlag', overrides: { order: 770, visible: true } },
        
            
            { key: 'deliveryId', overrides: { order: 840, visible: false } },
            { key: 'averageUnitPrice', overrides: { order: 850, visible: false } },
            { key: 'averageUnitCost', overrides: { order: 860, visible: false } },
            { key: 'extendedPrice', overrides: { order: 870, visible: false } },
            { key: 'extendedCost', overrides: { order: 880, visible: false } },
            { key: 'dynamicReserveExecutionDate', overrides: { order: 890, visible: false } },
            { key: 'deliveryDateMovedEarlyFlag', overrides: { order: 900, visible: false } },
            { key: 'optimizedDays', overrides: { order: 910, visible: false } },
            { key: 'expectedDeliveryDate', overrides: { order: 930, visible: false } },

            { key: 'customerLocationLatitude', overrides: { order: 940, visible: false } },
            { key: 'customerLocationLongitude', overrides: { order: 950, visible: false } }
];
